<template>
  <div class="rex-chart-slow">
    <div class="slow-header">
      {{ $t('recentAlerts') }}
    </div>
    <div class="slow-body">
      <div v-if="data.length === 0 && !loading">
        <NoData :message="$t('noData')"></NoData>
      </div>
      <Loading v-if="loading" />
      <div class="rex-chart-slow-i" v-for="(j, index) in getValue" :key="index">
        <div class="occurItem">
          <div class="occurCount">
            {{ j.docCount }}
          </div>
          <div class="occur">
            {{ $t('occurrences') }}
          </div>
        </div>
        <div class="alertMain">
          <div class="title">
            {{ j.alarmMessage }}
          </div>
          <div class="alertSub">
            <div class="subTime">
              {{
                $filters.dateformat(
                  parseInt(j.latest),
                  timezoneoffset,
                  dateTime,
                )
              }}
              <!-- {{ j.latest }} -->
            </div>
            <div class="subApp" @click="goToTrace(j.serviceId)">
              {{ j.serviceName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import rexProgress from '@/rex-components/rex-progress.vue';
import copy from '@/utils/copy';
import BaseIcon from '@/rex-components/BaseIcon.vue';
import { mapActions, mapState, mapGetters } from 'vuex';
import { dateTime } from '@/utils/time/dateconstants';
import NoData from '@/rex-components/rex-no-data.vue';
import Loading from '@/rex-components/rex-loading.vue';
export default {
  name: 'ChartAlert',
  components: { rexProgress, BaseIcon, NoData, Loading },
  data: function () {
    return {
      dateTime,
      data1: [
        {
          name: '/product/new',
          id: 'eydzZXJ2aWNlTmFtZSc6SkFWQV8yLCd0ZWFtSUQnOnRlYW0sJ2NhcGFiaWxpdHknOidBUE0nfQ==.1_L3Byb2R1Y3QvbmV3',
          value: 100,
          time: '12/09/20, 04:07:10 am',
          key: 'eydzZXJ2aWNlTmFtZSc6SkFWQV8yLCd0ZWFtSUQnOnRlYW0sJ2NhcGFiaWxpdHknOidBUE0nfQ==.1',
        },
        {
          name: '/',
          id: 'eydzZXJ2aWNlTmFtZSc6SkFWQV8yLCd0ZWFtSUQnOnRlYW0sJ2NhcGFiaWxpdHknOidBUE0nfQ==.1_Lw==',
          value: 100,
          time: '12/09/20, 04:07:10 am',
          key: 'eydzZXJ2aWNlTmFtZSc6SkFWQV80LCd0ZWFtSUQnOnRlYW0sJ2NhcGFiaWxpdHknOidBUE0nfQ==.1',
        },
      ],
      item: {
        width: 3,
        parentWidth: '57.8%',
        title: 'Endpoint by error %',
        icon: 'error',
        height: '12.5em',
        entityType: 'Endpoint',
        independentSelector: false,
        metricType: 'REGULAR_VALUE',
        metricName: 'endpoint_sla',
        queryMetricType: 'sortMetrics',
        chartType: 'ChartSlow',
        aggregation: '/',
        aggregationNum: '100',
        parentService: true,
        unit: '%',
        sortOrder: 'ASC',
        labels: { xAxis: 'Time', yAxis: '%' },
      },
    };
  },
  props: {
    data: {},
    i: {},
    loading: Boolean,
  },
  methods: {
    ...mapActions('apmState/apmCommonState', ['selectService']),
    getTraceId(i) {
      return i.traceIds && i.traceIds[0] ? ` - ${i.traceIds[0]}` : '';
    },
    handleClick(i) {
      copy(i);
    },
    getTracePage(trace) {
      this.showtrace = true;
      this.traceIdtoshow = trace.traceIds && trace.traceIds[0];
    },
    getApplication(key) {
      let data = this.services.filter((i) => i.key === key);
      console.log('data', data);
      if (data[0]) {
        return data[0].label;
      } else return '';
    },
    goToTrace(item) {
      let obj = {
        key: item,
        label: this.getApplication(item),
      };
      const params = {
        duration: this.getDurationTime,
        service: obj,
      };
      this.selectService(params);
      this.$router.push({
        name: 'trace',
      });
    },
  },
  computed: {
    ...mapState('globalState/settings', ['timezoneoffset']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('apmState/apmCommonState', ['services', 'currentService']),
    getValue() {
      if (this.data.length > 5) {
        return this.data.slice(0, 5);
      }
      return this.data;
    },
    maxValue() {
      if (!this.data.length) {
        return null;
      }
      const temp = this.data.map((i) => i.value);
      return Math.max.apply(null, temp);
    },
  },
};
</script>
<style lang="scss" scoped>
.rex-chart-slow {
  height: 100%;
  width: 100%;
}
.rex-chart-slow-i {
  display: flex;
  background-color: $bg-primary;
  height: 3.5em;
  margin-bottom: 0.875em;
  .alertMain {
    margin-left: 1.875em;
    align-items: left;
  }
  .title {
    display: flex;
    color: $font-primary;
    font-size: 0.875em;
    padding: 0.4em 0 0 0;
  }
  .alertSub {
    display: flex;
  }
  .subTime {
    color: $font-secondary;
    font-family: $semi-bold !important;
    font-size: 0.75em;
    padding: 0.4em 0 0 0;
  }
  .subApp {
    text-decoration: underline;
    color: $font-secondary;
    font-family: $semi-bold !important;
    font-size: 0.875em;
    padding: 0.2em 0 0 0.6em;
  }
  .subApp:hover {
    cursor: pointer;
  }
  .occurItem {
    margin-left: 1.2em;
  }
  .occurCount {
    padding-left: 0.25em;
    color: $blue-light;
    font-family: $semi-bold !important;
    font-size: 1.125em;
    padding: 0.4em 0 0 0;
  }
  .occur {
    color: $font-primary;
    font-family: $regular !important;
    font-size: 0.75em;
    padding: 0 0 0 0;
  }
}
.rex-chart-slow-i:first-child {
  margin-top: 0.75em;
}
.copy-icon {
  margin-left: auto;
  cursor: pointer;
  margin-right: 0.813em;
  @include svg-fill-pointer($font-primary);
}

.slow-body {
  height: 100%;
  margin-left: 1.625em;
  margin-right: 1.625em;
}

.slow-header {
  display: flex;
  padding: 0.4em 0 0.7em 1.25em;
  color: $font-primary;
  font-family: $semi-bold !important;
  font-size: 0.875rem;
  border-bottom: 0.0125em solid $border-primary;
}
.slow-header {
  text-align: left;
  height: 2.375em;
  border-top-left-radius: 1.0625em;
  border-top-right-radius: 1.0625em;
  padding-top: 0.625em;
  padding-left: 1.5em;
  font-size: 1.125em;
  font-family: $bold;
  color: $font-primary;
  padding: 0.4em 0 0.7em 1.25em;
}
</style>
